// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"67a0b1f2","66":"466daa9b","332":"35d01341","390":"02c22653","590":"e34b065f","698":"690a62a6"}[chunkId] + ".chunk.js";
};